import React from 'react';
import Component from '@vfuk/core-container';
const CoreContainer = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CoreContainer;
